import { SelectField, SelectFieldProps } from "src/components/common/inputFields/SelectField";
import { logError } from "src/errorHandling/errorLogging";
import { useAsyncFetch } from "src/utils/async/asyncFetch.ts";
import i18n from "i18next";

export interface LazySelectFieldProps<T, Key, DisableClearable extends boolean | undefined>
	extends Omit<SelectFieldProps<T, Key, DisableClearable>, "onFocus" | "loading" | "options"> {
	fetchOptions: () => Promise<T[]>;
	fetchOnMount?: boolean;
}

export const LazySelectField = <T, Key, DisableClearable extends boolean | undefined = undefined>({
	fetchOptions,
	fetchOnMount,
	error,
	...other
}: LazySelectFieldProps<T, Key, DisableClearable>) => {
	const [{ loading, error: optionsError, data }, update] = useAsyncFetch<T[]>(fetchOptions, {
		fetchOnMount: fetchOnMount,
	});

	const combinedError =
		error ?? (optionsError !== undefined ? i18n.t("failed_to_fetch_options") : undefined);

	return (
		<SelectField
			error={combinedError}
			options={data ?? []}
			loading={loading}
			onFocus={() => {
				update().catch(logError);
			}}
			{...other}
		/>
	);
};
